// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"83e6697b","457":"2a4435a1","551":"5c9039df","950":"d838c046"}[chunkId] + ".chunk.js";
};